import React from 'react';
import { Panel, Stack } from 'rsuite';
import {
  COMMISSIONS_DEFAULTS_IMPORT_PATH,
  COMMISSIONS_IMPORT_PATH,
  exportCommissions,
  exportDefaultCommissions,
} from '../api/pricing/commissions';
import PricingFileImport from '../components/PricingData/PricingFileImport';
import CommissionPricelistExport from '../components/CommissionPricelist/CommissionPricelistExport';

export enum CommissionPricelistType {
  PARTNER = 'PARTNER',
  DEFAULT = 'DEFAULT',
}

interface CommissionPricelistConfig {
  title: string;
  importLabel: string;
  exportLabel: string;
  importPath: string;
  exportFileName: string;
  exportPricelist: () => Promise<Blob>;
}

const CONFIGS: Record<CommissionPricelistType, CommissionPricelistConfig> = {
  [CommissionPricelistType.PARTNER]: {
    title: 'Commission Pricelist',
    importLabel: 'Import Pricelist',
    exportLabel: 'Export Pricelist',
    importPath: COMMISSIONS_IMPORT_PATH,
    exportFileName: 'commission_pricelist.xlsx',
    exportPricelist: exportCommissions,
  },
  [CommissionPricelistType.DEFAULT]: {
    title: 'Default Commission Pricelist',
    importLabel: 'Import Pricelist',
    exportLabel: 'Export Pricelist',
    importPath: COMMISSIONS_DEFAULTS_IMPORT_PATH,
    exportFileName: 'default_commission_pricelist.xlsx',
    exportPricelist: exportDefaultCommissions,
  },
};

interface Props {
  type: CommissionPricelistType;
}

export default function CommissionPricelist({ type }: Readonly<Props>) {
  const {
    title, importLabel, exportLabel, importPath, exportFileName, exportPricelist,
  } = CONFIGS[type];

  return (
    <Panel header={<h3>{title}</h3>}>
      <Stack spacing={40} className="mt-20">
        <PricingFileImport
          path={importPath}
          label={importLabel}
        />

        <CommissionPricelistExport
          label={exportLabel}
          fileName={exportFileName}
          onExport={exportPricelist}
        />
      </Stack>
    </Panel>
  );
}
